const common = require("lib/labels/_common");

// Contact

module.exports = {
  form: {
    name: common.name,
    company: common.company,
    subject: {
      en: "Subject",
      fr: "Objet"
    },
    send: common.send
  }
};
